import type { BumperEffectType } from "../types"

export type BumperFeedbackType = BumperEffectType

export interface BumperFeedbackDef {
  label: string
  title: string
  detail: string
  description: string
  color: string
  offsetY: number
  charge: number
}

export interface BumperCalloutValues {
  value1: number
  value2?: number
  unit1?: string
  unit2?: string
}

export const getCalloutValues = (
  type: BumperFeedbackType,
  level: number,
): BumperCalloutValues => {
  switch (type) {
    case "heal":
      return { value1: HEAL_BY_LEVEL[level - 1] ?? HEAL_AMOUNT, unit1: "HP" }
    case "levelup":
      return {
        value1: LEVELUP_XP_BY_LEVEL[level - 1] ?? LEVELUP_XP_AMOUNT,
        unit1: "XP",
      }
    case "bank":
      return {
        value1: BANK_DROP_COUNT_BY_LEVEL[level - 1] ?? BANK_DROP_COUNT,
        value2: BANK_DROP_VALUE_BY_LEVEL[level - 1] ?? BANK_DROP_VALUE,
        unit1: "coins",
      }
    case "guard":
      return {
        value1: Math.ceil(
          (GUARD_INVULNERABILITY_BY_LEVEL_MS[level - 1] ??
            GUARD_INVULNERABILITY_MS) / 1000,
        ),
        unit1: "s",
      }
    case "charge":
      return { value1: 1, unit1: "OD" }
  }
}

const HEAL_AMOUNT = 12
const LEVELUP_XP_AMOUNT = 6
const BANK_DROP_COUNT = 4
const BANK_DROP_VALUE = 8
const GUARD_INVULNERABILITY_MS = 950
const HEAL_BY_LEVEL = [8, 12, 18, 26, 36] as const
const LEVELUP_XP_BY_LEVEL = [4, 6, 9, 13, 18] as const
const BANK_DROP_COUNT_BY_LEVEL = [3, 4, 5, 6, 8] as const
const BANK_DROP_VALUE_BY_LEVEL = [5, 7, 9, 12, 16] as const
const GUARD_INVULNERABILITY_BY_LEVEL_MS = [650, 850, 1050, 1250, 1450] as const

export const BUMPER_OVERDRIVE_EFFECT: BumperEffectType = "charge"

export const BUMPER_FEEDBACK: Record<BumperFeedbackType, BumperFeedbackDef> = {
  charge: {
    label: "CHARGE",
    title: "CHARGE",
    detail: "",
    description:
      "Charges the Overdrive meter and teaches the core bumper loop.",
    color: "#fff7ad",
    offsetY: -44,
    charge: 1,
  },
  guard: {
    label: "GUARD",
    title: "GUARD",
    detail: "",
    description: "Wraps the hero in a short safety guard after the bounce.",
    color: "#e9d5ff",
    offsetY: -46,
    charge: 1,
  },
  bank: {
    label: "BANK",
    title: "BANK",
    detail: "",
    description: "Throws gold coins outward from the bumper.",
    color: "#fed7aa",
    offsetY: -48,
    charge: 1,
  },
  levelup: {
    label: "LEVEL UP",
    title: "LEVEL UP",
    detail: "",
    description: "Gives a small amount of XP to help the hero level up.",
    color: "#dcfce7",
    offsetY: -46,
    charge: 1,
  },
  heal: {
    label: "HEAL",
    title: "HEAL",
    detail: "",
    description: "Heals a fraction of the hero's life when bumped.",
    color: "#cffafe",
    offsetY: -46,
    charge: 1,
  },
}

export const getBumperCharge = (effect: BumperEffectType): number =>
  BUMPER_FEEDBACK[effect].charge
